export default "__VITE_ASSET__UQnQlZkZ__"